<div class="grid-wrapper" #gridWrapper>
  <pg-calendar-cursor
    [cellSize]="cellSize"
    #cursor="pgCalendarCursor"
  ></pg-calendar-cursor>
  <ng-container *ngFor="let day of monthArray; let i = index">
    <pg-calendar-grid-cell
      tabindex="0"
      [day]="day"
      [class.today]="isToday(day?.date)"
      [class.active]="dateCompare(day?.date, selectedDate)"
      [size]="cellSize"
      (click)="handleCellClicked(day)"
      (keydown)="handleCellKeydown($event, day)"
    ></pg-calendar-grid-cell>
  </ng-container>
</div>
